import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useCommonContext } from "./utils/context";

const PUBLIC_PAGES = [
  "/",
  "/about",
  "/features",
  "/pricing",
  "/contact",
  "/terms-conditions",
  "/privacy-policy",
  "/userdelete",
  "/signin",
  "/signup",
  "/otpverification",
];

const DataInitializer = () => {
  const location = useLocation();

  const {
    fetchUser,
    fetchTechnicians,
    fetchTickets,
    fetchAmcData,
    fetchCustomers,
    fetchSubscription,
    fetchStocks,
    fetchAllusers,
    fetchTicketStatus,
  } = useCommonContext();

  const isPublicPage = PUBLIC_PAGES.includes(location.pathname);

  useEffect(() => {
    if (isPublicPage) return;
    fetchUser();
    fetchTechnicians();
    fetchTickets();
    fetchTicketStatus();
    fetchStocks();
    fetchSubscription();
    fetchAllusers();
    fetchAmcData();
    fetchCustomers();
    const role = localStorage.getItem("role");

    let interval = null;

    if (["technician", "sales", "manager", "agent"].includes(role)) {
      interval = setInterval(() => {
        fetchUser();
      }, 10000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isPublicPage]);

  return null;
};

export default DataInitializer;
